import { render, staticRenderFns } from "./LeaveRequestBreakdown.vue?vue&type=template&id=2f04dfc9&scoped=true"
import script from "./LeaveRequestBreakdown.vue?vue&type=script&lang=js"
export * from "./LeaveRequestBreakdown.vue?vue&type=script&lang=js"
import style0 from "./LeaveRequestBreakdown.vue?vue&type=style&index=0&id=2f04dfc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04dfc9",
  null
  
)

export default component.exports